import { CostUnitLabelType } from '@/enum'

class PriceWithUnit  {
  value: number
  unit: string

  constructor(item?: any) {
    if (item?.value === undefined || item?.value === null || item?.value === '') {
      this.value = 0
    } else {
      this.value = item.value
    }
    this.unit = item?.unit ?? CostUnitLabelType.GBP
  }
}

export default PriceWithUnit
